import React from "react";
import SpeakerCard from "./card";
import styles from "./speaker.module.scss";

const data = [
  {
    memberId: 1,
    categoryId: 3,
    firstName: "Seline Francis Gom",
    middleName: "",
    lastName: "",
    email: "ceo@myunisearch.co",
    mobile: "",
    designationName: "Counsellor",
    biography: "",

    uuid: "y6rQfBaJIdXLTmBgQ7bEqUUS",
    sortOrder: "1",
    showInWebsite: 1,
    showInDetailsPage: 1,
    address: "",
    categorySlug: "management",
    countryName: "Australia",
    branchName: "Delhi",
    profileImageSrc:
      "https://cdn.myunisearch.com/ADMIN/Hina-Tarannum-924306c6-b603-4629-9fdb-a57b2f78479e.jpg",
  },
  {
    memberId: 2,
    categoryId: 3,
    firstName: "Ranvir Dutt",
    middleName: "",
    lastName: "",
    email: "ceo@myunisearch.co",
    mobile: "",
    designationName: "Senior Counsellor",
    biography: "",

    uuid: "y6rQfBaJIdXLTmBgQ7bEqUUS",
    sortOrder: "1",
    showInWebsite: 1,
    showInDetailsPage: 1,
    address: "",
    categorySlug: "management",
    countryName: "Australia",
    branchName: "Delhi",
    profileImageSrc:
      "https://cdn.myunisearch.com/ADMIN/1647925173453-8f73bacc-33bb-4cf2-ae2c-5ce04071275c.jpg",
  },
  {
    memberId: 3,
    categoryId: 3,
    firstName: "Jahnvi Sing",
    middleName: "",
    lastName: "",
    email: "ceo@myunisearch.co",
    mobile: "",
    designationName: "Counsellor",
    biography: "",

    uuid: "y6rQfBaJIdXLTmBgQ7bEqUUS",
    sortOrder: "1",
    showInWebsite: 1,
    showInDetailsPage: 1,
    address: "",
    categorySlug: "management",
    countryName: "Australia",
    branchName: "Delhi",
    profileImageSrc:
      "https://cdn.myunisearch.com/ADMIN/Hina-Tarannum-924306c6-b603-4629-9fdb-a57b2f78479e.jpg",
  },
  {
    memberId: 4,
    categoryId: 3,
    firstName: "Alex Martinez",
    middleName: "",
    lastName: "",
    email: "ceo@myunisearch.co",
    mobile: "",
    designationName: "Senior Counsellor",
    biography: "",

    uuid: "y6rQfBaJIdXLTmBgQ7bEqUUS",
    sortOrder: "1",
    showInWebsite: 1,
    showInDetailsPage: 1,
    address: "",
    categorySlug: "management",
    countryName: "Australia",
    branchName: "Delhi",
    profileImageSrc:
      "https://cdn.myunisearch.com/ADMIN/1647925173453-8f73bacc-33bb-4cf2-ae2c-5ce04071275c.jpg",
  },
];
export const EventSpeaker = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.heading_container}>
          <h2 className={styles.title}>
            Meet our 2022 <br /> Keynote Speakers
          </h2>
          {/* <div className={styles.bottom_border}></div> */}
          <p className={styles.subtitle}>
            A true suscipit ut error excepturi voluptas blanditiis beatae rerum
            consequatur odit omnis pariatur cum accusantium recusandae, quas
            delectus repellat.
          </p>
        </div>
        {data?.length > 0 && (
          <div className={styles.card_container}>
            {data?.map((list, i) => {
              return <SpeakerCard data={list} key={i} />;
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default EventSpeaker;
